module.exports = __webpack_public_path__ + "static/img/img_logo_8.70e88936.png";